import requests from "./httpService";

const DesignationService = {
    getCompanyDesignation(companyId, body) {
        return requests.get(`/designations/designation/aggreegate?company_id=${companyId}`, body);
    },
    createDesignation(body) {
        return requests.post(`/designations/designation/create`, body);
    },
    deleteDesignation(id, companyId) {
        return requests.delete(`/designations/designation/delete/${id}?company_id=${companyId}`);
    },
    editDesignation(id, body) {
        return requests.post(`/designations/designation/update/${id}`, body);
    },
    updateDesignation(id) {
        return requests.post(`/designations/designation/statusupdate/${id}`);
    },
};

export default DesignationService;
